import { Variable } from '../../../../common/models'
import { Modal } from '@/components/ui/modal'
import { Button } from '@/components/ui/button'
import { PageTitle } from '@/components'

export interface InsertVariableModalProps {
  showModal: boolean
  setShowModal: (show: boolean) => void
  variables: Variable[]
  setInsertVariable: (s: string) => void
}

export const InsertVariableModal = (
  props: InsertVariableModalProps,
): JSX.Element => {
  const { showModal, setShowModal, setInsertVariable, variables } = props

  const handleClose = () => {
    setShowModal(false)
  }

  return (
    <Modal
      open={showModal}
      onOpenChange={setShowModal}
      title={
        <div className="border-b border-monochrome-120 pb-4">
          <PageTitle title="Insert Variable" />
        </div>
      }
      size="lg"
      footer={
        <div className="flex justify-end w-full gap-2">
          <Button onClick={handleClose} variant="secondary">
            Cancel
          </Button>
          <Button onClick={handleClose} variant="primary">
            Insert
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-6">
        {variables.map((variable, index) => (
          <div key={variable.key} className="flex flex-col gap-3">
            <div className="text-xl font-medium leading-tight text-monochrome-1">
              {variable.key}
            </div>
            <div className="text-base text-monochrome-2 leading-normal">
              {variable.description}
            </div>
            <Button
              onClick={() => {
                setInsertVariable(`{${variable.key}}`)
              }}
              variant="secondary"
              className="w-full"
            >
              Insert
            </Button>
            {index < variables.length - 1 && (
              <div className="border-t border-monochrome-120 w-full" />
            )}
          </div>
        ))}
      </div>
    </Modal>
  )
}
